import { get } from "lodash";

export const isEnabled = (state, feature) =>
  get(state, `features.${feature}`, false);
